import React from 'react';
import { Routes, Route } from 'react-router-dom';

// landing
import LandingPage from '../View/Landing/index';

// Global
import GlobalManinPage from '../View/Global/Components/Home/index';
import GlobalServices from '../View/Global/Components/Servises/index';
import GlobalAbout from '../View/Global/Components/About/index';
import GlobalBlogs from '../View/Global/Components/Blogs/index';
import GlobalConatctUs from '../View/Global/Components/ContactUs/index';
import GlobalOurServices from '../View/Global/Components/Our_services/index';

// Local
import LocalManinPage from '../View/Local/Components/Home/index';
import LocalServices from '../View/Local/Components/Servises/index';
import LocalAbout from '../View/Local/Components/About/index';
import LocalBlogs from '../View/Local/Components/Blogs/index';
import LocalConatctUs from '../View/Local/Components/ContactUs/index';
import LocalOurServices from '../View/Local/Components/Our_services/index';

function AppRoutes() {
  return (
    <Routes>
      {/* Landing */}
      <Route path="/" element={<LandingPage />} />
      {/* Global */}
      <Route path="/global" element={<GlobalManinPage/>} />
      <Route path="/global/servises" element={<GlobalServices/>} />
      <Route path="/global/about" element={<GlobalAbout/>} />
      <Route path="/global/blogs" element={<GlobalBlogs/>} />
      <Route path="/global/contact-us" element={<GlobalConatctUs/>} />
      <Route path="/global/our-services" element={<GlobalOurServices/>} />
      {/* Local */}
      <Route path="/Sri_Lanka" element={<LocalManinPage/>} />
      <Route path="/Sri_Lanka/servises" element={<LocalServices/>} />
      <Route path="/Sri_Lanka/about" element={<LocalAbout/>} />
      <Route path="/Sri_Lanka/blogs" element={<LocalBlogs/>} />
      <Route path="/Sri_Lanka/contact-us" element={<LocalConatctUs/>} />
      <Route path="/Sri_Lanka/our-services" element={<LocalOurServices/>} />
    </Routes>
  );
}

export default AppRoutes;
